
import { ModalState } from 'kinetic-angular';
import { BusinessAccountRequestState, EditAdminCompanyDetailsAemLabels } from './definitions';
import { CssClass, ModalButtonId } from '../../services/shared/shared-enums';
import { mockedState } from '../../constants/business-account-request-data';

export class BusinessAccountRequestFactory 
{
	public static build(): BusinessAccountRequestState 
	{
		return { ...mockedState };
	}
	public static buildEditAdminCompanyDetails(): EditAdminCompanyDetailsAemLabels 
	{
		return {
			heading: '',
			closeIcon: { altText: '', iconPath: '' },
			errorText: {
				invalidCharacterWithNumericErrorMessage: 'Please enter only letters, numbers, hyphens, apostrophe, commas or periods',
				invalidCharacterWithoutNumericErrorMessage: 'Please enter a valid character',
				requiredErrorMessage: '$token is a required field',
				minLengthZipCodeError: 'Postal code should have 5 numeric characters',
				canadaPostalCodeFormatError: 'Postal Code format is incorrect. Please enter the correct Postal Code'
			},
			pageLabels: {
				companyName: { id: '', label: '' },
				addressLine1: { id: '', label: '' },
				addressLine2: { id: '', label: '' },
				country: { id: '', label: '' },
				city: { id: '', label: '' },
				state: { id: '', label: '' },
				zipCode: { id: '', label: '' }
			},
			pageButtons: [{
				cancel: { id: '', label: '' },
				save: { id: '', label: '' }
			}]
		};
	}
	public static buildEditAdminCompanyDetailsModalState(): ModalState 
	{
		return {
			hidden: true,
			label: '',
			buttons: [
				{ label: '', disabled: false, cssClass: CssClass.btnSecondary, id: ModalButtonId.cancel },
				{ label: '', disabled: false, cssClass: CssClass.btnBlack, id: ModalButtonId.save }
			],
			cssClass: CssClass.removeLocationTitle
		};
	}
	public static buildUploadModelState(): ModalState
	{
		return {
			hidden: true,
			label: '',
			buttons: [
				{ label: '', disabled: false, cssClass: CssClass.btnSecondary },
				{ label: '', disabled: false, cssClass: CssClass.btnBlack }
			],
			cssClass: CssClass.uploadFileTitle
		};
	}
}
